export default [
    {
        name: "version",
        path: "/internal/version",
        component: () => import(/* webpackChunkName: "internal" */ "@/views/internal/VersionView.vue"),
        meta: {
            public: true
        },
    },
]
